import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IDealCard } from 'src/app/modules/shared/models';
import { DataService } from 'src/app/services/data/data.service';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services';
import { Theme, initialThemeState } from 'src/app/modules/redux';
import { Title } from '@angular/platform-browser';
import { DealPreviewService } from '../../../deals/services/deal-preview.service';
import { UtilService } from 'src/app/modules/shared/services';
import { InterestedInDealModalComponent } from '../interested-in-deal-modal/interested-in-deal-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalSize } from '../../services/util/util.service';
import { MatTableDataSource } from '@angular/material/table';
import { IDocument } from 'src/app/modules/deals/models/i-document';

@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss']
})
export class PreviewComponent implements OnInit {

  dealId: string = '';
  deal!: IDealCard;
  theme: Theme = initialThemeState;
  isStandalonePage: boolean = true;

  userIsLoggedIn: boolean = false;

  documentName: string[] = ['documentName', 'size', 'fileType', 'actions'];
  dataSource = new MatTableDataSource<any>();
 
  constructor(
    private activedRoute: ActivatedRoute,
    private dealPreviewService: DealPreviewService,
    private dataService: DataService,
    private toastr: ToastrService,
    private authService: AuthService,
    private util: UtilService,
    private router: Router,
    private title: Title,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.dealId = this.activedRoute.snapshot.paramMap.get('dealId') || '';

    // console.log("is this from a BU or just preview", this.activedRoute.snapshot.parent?.paramMap.get('id'));
    this.isStandalonePage = this.activedRoute.snapshot.parent?.paramMap.get('id') == null;

    if (!this.dealId) {
      this.toastr.error("Deal not found!");
      this.util.sendUserToErrorPage("Deal Not Found!");
      return;
    }

    this.dealPreviewService.getDealPreviewById(this.dealId).subscribe({
      next: (deal: IDealCard) => {
        this.deal = deal;

        // change the title if this is a standalone page
        if (this.isStandalonePage) {
          this.title.setTitle("Deal Preview | " + this.deal.projectName);
        }

        this.dealPreviewService.getDealPreNdaDataroom(this.dealId).subscribe({
          next: (docs: IDocument[]) => {
            this.dataSource.data = docs || [];
          }
        });
      },
      error: (err) => {
        console.error("Error fetching deal preview", err);  
        this.toastr.error("Deal not found!");
        this.util.sendUserToErrorPage("Deal Not Found!");
      }
    });

    // return;
    // this.dealPreviewService.getLiveDealsPreview().subscribe({
    //   next: (deals: IDealCard[]) => {
    //     // console.log("All live deals", deals)
    //     var selectedDeal = deals.filter(x => x.id == this.dealId);

    //     if (selectedDeal.length == 0) {
    //       this.toastr.error("Deal not found!");
    //       this.util.sendUserToErrorPage("Deal Not Found!");
    //       return;
    //     }

    //     this.deal = selectedDeal[0];

            
    //     // // check the route for actions
    //     // var action = this.activedRoute.snapshot.queryParamMap.get("action");
    //     // // this.toastr.success("Action = " + action || 'none');
    //     // if (action === "express-interest") {
    //     //   // open the express interest modal
    //     //   setTimeout(() => {
    //     //     this.expressInterestInDeal();
    //     //   }, 1500);
    //     // }

    //     this.title.setTitle("Deal Preview | " + this.deal.projectName);

    //     this.dealPreviewService.getDealPreNdaDataroom(this.dealId).subscribe({
    //       next: (docs: IDocument[]) => {
    //         this.dataSource.data = docs || [];
    //       }
    //     });
    //   }
    // });
  }

  goToDashboard() {
    this.router.navigate(['/']);
  }

  downloadDocument(doc: IDocument) {
    console.log("Download document", doc);

    if (!doc) {
      this.toastr.error("Document not available for download.");
      return;
    }

    this.dealPreviewService.getDealPreNdaDataroomDocumentById(doc.id).subscribe({
      next: (res: any) => {
        let blob: Blob = res as Blob;
        var filename = doc.documentName + '.' + doc.fileType.toLowerCase();
        let a = document.createElement('a');
        a.download = filename;
        a.href = window.URL.createObjectURL(blob);
        a.click();
      }
    });
  }

  requestMoreInformation() {
    this.dialog.open(InterestedInDealModalComponent, {
      data: {
        deal: this.deal
      },
      width: this.util.getModalWidth(ModalSize.SMALL)
    })
    .afterClosed().subscribe(result => {
      console.log("Dialog closed", result);
    });
  }

  requestDealMatch() {
    var payload = {
      dealId: this.dealId,
    };

    this.dealPreviewService.sendDealInterestAsUser(payload).subscribe({
      next: (res) => {
        console.log("User interest sent", res);
        this.toastr.success("Rondeivu is reviewing your request to be matched to this deal. We will be in touch with you shortly.");
      },
      error: (err) => {
        console.error("Error sending deal interest", err);
        this.toastr.error("There was an error sending your request. Please try again later.");
      }
    });
  }

}
